import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import * as CoreActions from '@app/core/store/core.action';
import { ActivatedRoute } from '@angular/router';
import { selectSettingsState } from '@app/modules/settings/store/selectors/settings.selectors';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.scss']
})
export class ReportListComponent implements OnInit, OnDestroy {
  public isLoading$: boolean = false;
  public locUsesAssetModule: number = 0;
  public locUsesSerializedModule: number = 0;
  private subs: SubSink = new SubSink();

  constructor(
    private _store: Store,
    public route: ActivatedRoute,
  ) {
    this._store.dispatch(CoreActions.setTitle({ title: this.route.snapshot.data['title']}));
  }

  ngOnInit(): void {
    this.subs.add(
      this._store.select(selectSettingsState).subscribe((settings) => {
        this.locUsesAssetModule = Number(settings.locUsesAssetModule) || 0;
        this.locUsesSerializedModule = Number(settings.locUsesSerializedModule) || 0;
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
